/** @jsxImportSource @emotion/react */
import React from 'react';

import {css} from '@emotion/react';

import Loading from '@/assets/icons/Loading.gif';
import {fontSize, LAYOUT} from '@/constants/appStyle';
import {FONT_SIZE as FontSize} from '@/constants/pcConstAppData';

// TODO need to change this into (generic component | pure component) of wifi system settings cause of same component style
function WaitingAvailableWifiList() {
  const WaitingAvailableWifiListStyle = css({
    height: `calc(${LAYOUT.heightResolution} - (${LAYOUT.bottomMenuHeight} + ${LAYOUT.topMenuHeight}))`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',

    p: {
      color: 'grey',
      margin: '20px',
      fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    },
  });

  return (
    <div css={WaitingAvailableWifiListStyle}>
      <img
        src={Loading}
        alt={Loading}
        width={125}
        height={125}
      />
      <p>Please Wait!</p>
    </div>
  );
}
export default React.memo(WaitingAvailableWifiList);
